import type { GetFuneralHomeSettingNormalized } from '@messenger/types'
import axios from '@/api/axios.config'

export const getFuneralHomeSettings = async () => {
  return await axios.get<GetFuneralHomeSettingNormalized>(`funeralHomeSettings`)
}
